import { RootPortal } from '~/components/RootPortal';
import { PreferencesModal } from '~/components/v2/ModalTemplates/PreferencesModal';
import { useUserLocationController } from '~/hooks/useUserLocation/useUsersLocation';
import { useEnablePreferencesModal } from '~/hooks/useUserPreferences/useEnablePreferencesModal';
import LocationModal from '~/pages/Authenticated/InApp/modals/LocationModal';

export const LayoutModals = () => {
  const {
    location,
    showLocationModal,
    closeLocationModal,
    handleLocationChange,
  } = useUserLocationController();

  const { modalRef: preferencesModalRef, onPressButton } =
    useEnablePreferencesModal();

  return (
    <RootPortal>
      {/* Location Modal */}
      <LocationModal
        isOpen={showLocationModal}
        onClose={closeLocationModal}
        onSubmit={handleLocationChange}
        initialLocation={location}
      />

      <PreferencesModal
        onPressButton={onPressButton}
        modalRef={preferencesModalRef}
      />
    </RootPortal>
  );
};
